import { render } from "./VendorSlider.vue?vue&type=template&id=2e2b3096&scoped=true"
import script from "./VendorSlider.vue?vue&type=script&lang=js"
export * from "./VendorSlider.vue?vue&type=script&lang=js"

import "./VendorSlider.vue?vue&type=style&index=0&id=2e2b3096&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2b3096"]])

export default __exports__